'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var ArrayField$1 = require('../ArrayField.js');
var FormComponents = require('../FormComponents.js');
var FormFields = require('../FormFields.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["name", "items", "uiBefore", "uiAfter"];
var ArrayField = function ArrayField(_ref) {
  var name = _ref.name,
    items = _ref.items,
    uiBefore = _ref.uiBefore,
    uiAfter = _ref.uiAfter,
    props = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);
  // const ArrayField = ({ name, items, ...props }) => {
  // const { 'ui:props': uiProps = {} } = items;
  return /*#__PURE__*/React__default["default"].createElement(ArrayField$1.ArrayField, _rollupPluginBabelHelpers["extends"]({
    name: name
  }, props), /*#__PURE__*/React__default["default"].createElement(FormComponents.FormComponents, {
    components: uiBefore
  }), /*#__PURE__*/React__default["default"].createElement(ArrayField$1.ArrayField.Items, null, function () {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(FormFields.FormFields, {
      schema: items
    }));
  }), /*#__PURE__*/React__default["default"].createElement(FormComponents.FormComponents, {
    components: uiAfter
  }));
};

exports.ArrayField = ArrayField;
